import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  return (
    <div className="contact" id="contact">
      <div className="main-content">
        <div class="contact-content">
          <Link to="/"> Home </Link>
          <Link
            to="/about"
          >
            About
          </Link>
        </div>

        <div className="contact-content">
          <Link to="/feedback"> Feedback </Link>
          <Link to="mailto:mail@hugenottenrathaus.de" target="_blank">
            Contact
          </Link>
        </div>

        <div className="contact-content">
          <Link
            to="https://www.facebook.com/profile.php?id=100063584140400"
            target="_blank"
          >
            Facebook
          </Link>
          <Link to="https://hugenottenrathaus.de/" target="_blank">
            Website
          </Link>
        </div>
      </div>

      {/* <div class="action">
        <form onSubmit={(event) => event.preventDefault()}>
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            required
          ></input>
          <input type="submit" name="submit" value="Submit" required></input>
        
        </form>
      </div> */}
      <div class="last">
        <p>2024 AR App-Free | All Rights Reserved</p>
      </div>
    </div>
  );
}

export default Footer;
